import { UUID_STATUS } from "constants/config";
import AppUtils from "../../../util/util";
import {
    REPORT_FILTERS_COMPANY_POST_UPDATE_DATE_RANGE,
    REPORT_FILTERS_COMPANY_POST_SET_DATE_RANGE
} from '../../../constants/actions/reports/actionsReportFilters';
import {
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_SUCCESS,
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_STATUS_SUCCESS,
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_ERROR,
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_STATUS_ERROR,
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_IN_PROGRESS,
    COMPANY_POST_RAW_DATA_RESPONSES_UUID_NONE,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_SUCCESS,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_STATUS_ERROR,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_NONE,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_STATUS_SUCCESS,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_IN_PROGRESS,
    COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_ERROR,
} from "../../../constants/ActionTypes";
import { HTTP_REQUEST_STATUS } from "../../../constants/constants";

let selectionRange = AppUtils.getDefaultDateRangeSelection();
let timeResult = AppUtils.getReportsDates();

const initialData = {
    companyPostSelectionRange: selectionRange,
    reportEndDateStr: timeResult['end_date_str'],
    reportStartDateStr: timeResult['start_date_str'],
    companyPostRefreshCounter: 0,
    tableHeaders: [],
    tableData: [],
    loader: false,
    alertMessage: '',
    companyPostRawDataFetchStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    companyPostRawDataResponseUUID: "",
    companyPostRawDataResponseUUIDCounter: 0,
    companyPostRawDataDownloadStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    companyPostRawDataDownloadUUIDStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    companyPostRawDataResponseDownloadLink: "",
    companyPostRawDataDownloadUUID: "",
    companyPostRawDataDownloadUUIDCounter: 0
};

const ReducerCompanyPostReports = (state = initialData, action) => {

    switch (action.type) {
        /**to update company post date range */
        case REPORT_FILTERS_COMPANY_POST_UPDATE_DATE_RANGE: {
            return {
                ...state,
                companyPostSelectionRange: action.payload
            };
        }

        /** to set company post date range**/
        case REPORT_FILTERS_COMPANY_POST_SET_DATE_RANGE: {

            let timeResult = AppUtils.getReportsDates(action.payload.startDate, action.payload.endDate);

            return {
                ...state,
                reportEndDateStr: timeResult['end_date_str'],
                reportStartDateStr: timeResult['start_date_str'],
                companyPostRefreshCounter: state.companyPostRefreshCounter + 1
            };
        }

        /***************************************CompanyPost Raw data Responses UUID/status**************************** */

        /** to set state, on successful api call**/
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_STATUS_SUCCESS:
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_SUCCESS: {

            let tableHeaders = [];
            let tableData = [];
            let companyPostRawDataResponseUUID = state.companyPostRawDataResponseUUID;
            let companyPostRawDataResponseUUIDCounter = state.companyPostRawDataResponseUUIDCounter;
            let companyPostRawDataFetchStatus = state.companyPostRawDataFetchStatus;
            let loader = state.loader;

            if (action.payload && action.payload.message) {

                let message = action.payload.message;

                switch (message['status']) {
                    case UUID_STATUS.SUCCESS: {

                        let data = message.data && message.data.data;

                        if (data) {
                            tableHeaders = getCompanyPostRawDataTableHeaders(data);
                            tableData = data;
                        }
                        companyPostRawDataResponseUUID = "";
                        companyPostRawDataFetchStatus = HTTP_REQUEST_STATUS.NOT_STARTED;
                        loader = false;
                        break;
                    }
                    case UUID_STATUS.IN_PROGRESS: {
                        companyPostRawDataResponseUUID = message['uuid'];
                        companyPostRawDataResponseUUIDCounter += 1;
                        break;
                    }
                    case UUID_STATUS.NOT_FOUND: {
                        companyPostRawDataResponseUUIDCounter = 0;
                        companyPostRawDataResponseUUID = "";
                        companyPostRawDataFetchStatus = HTTP_REQUEST_STATUS.NOT_STARTED;
                        loader = false;
                        break;
                    }
                }
            }

            return {
                ...state,
                tableHeaders: tableHeaders,
                tableData: tableData,
                companyPostRawDataFetchStatus: companyPostRawDataFetchStatus,
                companyPostRawDataResponseUUID: companyPostRawDataResponseUUID,
                companyPostRawDataResponseUUIDCounter: companyPostRawDataResponseUUIDCounter,
                loader: loader
            };
        }

        /** to set state, on failed api call**/
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_STATUS_ERROR:
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_ERROR: {
            return {
                ...state,
                alertMessage: action.payload,
                companyPostRawDataFetchStatus: HTTP_REQUEST_STATUS.FAIL,
                loader: false,
                tableHeaders: [],
                tableData: [],
                companyPostRawDataResponseUUID: "",
                companyPostRawDataResponseUUIDCounter: 0,
            };
        }

        /** to set state, for none**/
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_NONE: {
            return {
                ...state,
                companyPostRawDataFetchStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
                loader: false,
                tableHeaders: [],
                tableData: [],
                companyPostRawDataResponseUUID: "",
                companyPostRawDataResponseUUIDCounter: 0,
            };
        }

        /** to set state, on api call in progress**/
        case COMPANY_POST_RAW_DATA_RESPONSES_UUID_IN_PROGRESS: {
            return {
                ...state,
                companyPostRawDataFetchStatus: HTTP_REQUEST_STATUS.IN_PROGRESS,
                tableHeaders: [],
                tableData: [],
                companyPostRawDataResponseUUID: "",
                companyPostRawDataResponseUUIDCounter: 0,
                loader: true
            };
        }

        /****************************************CompanyPost Raw data Download UUID/status****************************** */

        /** to set state, on api call for raw data UUID success**/
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_STATUS_SUCCESS:
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_SUCCESS: {

            let companyPostRawDataResponseDownloadLink = state.companyPostRawDataResponseDownloadLink;
            let companyPostRawDataDownloadUUID = state.companyPostRawDataDownloadUUID;
            let companyPostRawDataDownloadUUIDCounter = state.companyPostRawDataDownloadUUIDCounter;
            let loader = state.loader;
            let companyPostRawDataDownloadUUIDStatus = state.companyPostRawDataDownloadUUIDStatus;

            if (action.payload && action.payload.message) {

                let message = action.payload.message;

                switch (message['status']) {
                    case UUID_STATUS.SUCCESS: {
                        companyPostRawDataResponseDownloadLink = AppUtils.redirectDownloadProdToReports(action.payload.message.data.data);
                        companyPostRawDataDownloadUUID = "";
                        loader = false;
                        companyPostRawDataDownloadUUIDStatus = HTTP_REQUEST_STATUS.NOT_STARTED;
                        break;
                    }
                    case UUID_STATUS.IN_PROGRESS: {
                        companyPostRawDataDownloadUUID = action.payload.message.uuid;
                        companyPostRawDataDownloadUUIDCounter += 1;
                        break;
                    }
                    case UUID_STATUS.NOT_FOUND: {
                        companyPostRawDataDownloadUUID = "";
                        companyPostRawDataResponseDownloadLink = "";
                        companyPostRawDataDownloadUUIDStatus = HTTP_REQUEST_STATUS.NOT_STARTED;
                        loader = false;
                        break;
                    }
                }

            }

            return {
                ...state,
                companyPostRawDataDownloadUUIDStatus: companyPostRawDataDownloadUUIDStatus,
                companyPostRawDataResponseDownloadLink: companyPostRawDataResponseDownloadLink,
                companyPostRawDataDownloadUUID: companyPostRawDataDownloadUUID,
                companyPostRawDataDownloadUUIDCounter: companyPostRawDataDownloadUUIDCounter,
                loader: loader
            };
        }

        /** to set state, on api call for raw data UUID in progress**/
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_IN_PROGRESS: {
            return {
                ...state,
                companyPostRawDataDownloadUUIDStatus: HTTP_REQUEST_STATUS.IN_PROGRESS,
                companyPostRawDataResponseDownloadLink: "",
                companyPostRawDataDownloadUUIDCounter: 0,
                companyPostRawDataDownloadUUID: "",
                loader: true
            };
        }

        /** to set state, raw data UUID none**/
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_NONE: {
            return {
                ...state,
                companyPostRawDataDownloadUUIDStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
                companyPostRawDataResponseDownloadLink: "",
                companyPostRawDataDownloadUUID: "",
                companyPostRawDataDownloadUUIDCounter: 0
            };
        }

        /** to set state, on api call for raw data UUID failure**/
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_ERROR:
        case COMPANY_POST_RAW_DATA_RESPONSES_DOWNLOAD_UUID_STATUS_ERROR: {
            return {
                ...state,
                companyPostRawDataDownloadUUIDStatus: HTTP_REQUEST_STATUS.FAIL,
                companyPostRawDataDownloadUUID: "",
                companyPostRawDataDownloadUUIDCounter: 0,
                alertMessage: action.payload
            };
        }

        default:
            return {
                ...state
            };
    }
};

/****To get the table Headers ****/
function getCompanyPostRawDataTableHeaders(data) {

    let headers = [];

    try {
        if (data && data.length > 0) {
            headers = Object.keys(data[0]);
        }
    } catch (ex) {
        console.error('getCompanyPostRawDataTableHeaders : Error :' + ex);
    }
    return headers;
}

export default ReducerCompanyPostReports;